import {
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import { usePedidoContext } from "../../Context/PedidoContext";
import { IoTicketOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { HiTrash } from "react-icons/hi2";
import Swal from "sweetalert2";
import { queryClient } from "../../libs/queryClient";
import { Bilhete } from "../../utils/interfaces";
import { useMutationCancelarBilhete } from "../../hooks/cancelar/mutationCancelarBilhete";
import { Loading } from "../../components/Loading";
import { getUser, isRepresentante } from "../../libs/auth";


export function Bilhetes() {
  const { pedido, reload, removerAssentoLayout } = usePedidoContext();
  const navigate = useNavigate();
  const mutation = useMutationCancelarBilhete()
  const user = getUser();
  const representanteOnly = isRepresentante();

  const userAgenciaId = user?.agencia?.id;
  const pedidoAgenciaId = pedido?.agencia_id;
  const canCancelBilhete = !representanteOnly || (pedidoAgenciaId !== undefined && String(pedidoAgenciaId) === String(userAgenciaId));

  if(mutation.isPending) return <Loading />

   const onCancelar = async (bilhete: Bilhete) => {
      try {
        Swal.fire({
          title: "Tem certeza que deseja cancelar este bilhete?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then(async (response) => {
          if (response.isConfirmed) {
            
            await mutation.mutateAsync(bilhete.id)
            removerAssentoLayout(bilhete.assento)
            reload()
            queryClient.invalidateQueries({ queryKey: ["pedido"], exact: false });
          }
        });
      } catch (error) {
        console.error(error);
      }
    };
  

  const bilhetes = Array.isArray(pedido?.bilhetes) ? pedido.bilhetes : [];
  const existsBilhetes = bilhetes.length > 0;

  const handleIrParaPagamento = async () => {
    if (!pedido) return;

    navigate(`/pagamento/${pedido.id}`);
  };

  return (
    <Box>
      <Text fontWeight={"bold"} mt={2}>
        Poltronas Selecionadas
      </Text>

      <TableContainer maxHeight={"40vh"} overflowY={"auto"}>
        <Table
          fontSize={"sm"}
          colorScheme="gray"
          variant={existsBilhetes ? "striped" : "simple"}
        >
          <Thead bg={"#333333"} position={"sticky"} width={"100%"}>
            <Tr width={"100%"}>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                #
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Tipo de Viagem
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Poltrona
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Passageiro
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Documento
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Nascimento
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              ></Th>
            </Tr>
          </Thead>
          <Tbody height={"100%"}>
            {existsBilhetes ? (
              bilhetes.map((bilhete) => (
                <Tr fontSize={"small"} key={bilhete.id}>
                  <Td p={0} textAlign={"center"}>
                    {bilhete.id}
                  </Td>
                  <Td p={0} textAlign={"center"}>
                    {bilhete.contexto === "volta" ? "Volta" : "Ida"}
                  </Td>
                  <Td p={0} textAlign={"center"}>
                    {bilhete.assento}
                  </Td>
                  <Td p={0} textAlign={"center"}>
                    {bilhete.passageiro.nome}
                  </Td>
                  <Td p={0} textAlign={"center"}>
                    {bilhete.passageiro.documento}
                  </Td>
                  <Td p={0} textAlign={"center"}>
                    {bilhete.passageiro.data_nascimento}
                  </Td>
                  <Td p={0} textAlign={"center"}>
                    {canCancelBilhete && (
                      <Tooltip label="Cancelar bilhete">
                        <IconButton
                          onClick={() => onCancelar(bilhete)}
                          icon={<HiTrash />}
                          size={'sm'}
                          aria-label="cancelar"
                          variant={"solid"}
                          colorScheme="red"
                        />
                      </Tooltip>
                    )}
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={6}>
                  <Box
                    flexDir={"column"}
                    display={"flex"}
                    width={"100%"}
                    height={"20px"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <IoTicketOutline size={"48px"} color="'gray.500" />
                    <Text color={"gray.500"}>Selecione uma poltrona</Text>
                  </Box>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
      {pedido !== null && bilhetes.length > 0 && (
        <Flex justifyContent={"end"} mt={3}>
          <Button
            onClick={handleIrParaPagamento}
            bgColor={"#24c5ff"}
            border={"1px solid black"}
            color={"white"}
            fontSize={"2xl"}
            size={"lg"}
          >
            PRÓXIMO{">>>"}
          </Button>
        </Flex>
      )}
    </Box>
  );
}
